if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openerMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${openerMediaId}"]`);
        // Third reader of data-media-id, and the only one that actually throws.
        // The other two (global.js updateMedia, media-gallery.js setActiveMedia)
        // are guarded; leaving this one bare is how a localized opener whose id
        // is absent from the lightbox turned into a blank, focus-trapped,
        // scroll-locked overlay on mobile — super.show() has already run by the
        // time this executes, so the modal is open and body scroll is off.
        //
        // The bail is ABOVE the deactivation sweep, for the same reason
        // media-gallery.js setActiveMedia() bails before its is-active sweep:
        // the :not() below matches EVERYTHING when the id is absent, so sweeping
        // first would strip .active off every item and still leave a blank
        // lightbox below 750px, just without the TypeError. This modal persists
        // in the DOM between opens, so returning early keeps the previously
        // viewed item showing — a stale image rather than nothing.
        //
        // The markup should always match (asserted by the opener-join check in
        // tests/product-media-gallery-order.mjs); this is the backstop.
        if (!activeMedia) return;
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openerMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
